module.exports = __webpack_public_path__ + "static/media/sepaInst.30f25567.svg";